import { render, staticRenderFns } from "./ProductCateDetail.vue?vue&type=template&id=c79f62ca&scoped=true&"
import script from "./ProductCateDetail.vue?vue&type=script&lang=js&"
export * from "./ProductCateDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79f62ca",
  null
  
)

export default component.exports